<template>
 <div class="homepage">
   <NavbarComponent :loadingStatus="loading">Navigator Rule Readiness</NavbarComponent>
   <br>
<section>
<div class="container is-fluid">
  <input v-model="nodeId" placeholder="nodeId">
<button class="is-primary" @click="getRuleReadinessData"> Go! </button>
Node Dimensions: {{nodeDimensions}}
<br>
Not Ready Rules: 

<div v-for="node in falseNodeRules">
  {{node.nodeName}} RuleId: {{node.ruleId}}
  Missing Paramters: <template v-for="missingParameter in node.ruleState.missingScriptValueTypePoints">
    {{missingParameter.name}}
    </template>
  </div>

</div>
</section>
 </div>
</template>

<script>
import NavbarComponent from '@/components/NavbarComponent.vue'
import _ from 'lodash'
import axios from 'axios'

export default {
  name: "NavigatorRuleReadiness",
  components: {NavbarComponent, },
  data () {
    return {
      loading: false,
      nodeId: '1046288',
      nodeDimensions:[],
      nodeData: [],
    }
  },
  computed: {


  falseNodeRules: function(){
  return this.nodeData.filter(node => node.ruleState !== null).filter(node => node.ruleState.ready == false)  // remove nulls and filter for false
},
  trueNodeRules: function(){
  return this.nodeData.filter(node => node.ruleState !== null).filter(node => node.ruleState.ready == true)  // remove nulls and filter for true
}


},
  methods: {
   getNodeDimensions(nodeId){
            this.loading=true;
             const url = this.$store.getters.proxyurl + "https://eadvantage.siemens.com/remote/release/node/" + nodeId.toString() + "/dimlevels?includeRoot=true&sort=sortOrder&dir=ASC";
             
             //return for the async await
                 return axios({ method: 'get',url: url,headers: {'Accept': 'application/json','Content-Type': 'x-www-form-urlencoded',},auth: {username: this.$store.getters.navigatorUsername,password: this.$store.getters.navigatorPassword},
            }).then(response => {
              this.nodeDimensions= response.data
                 this.loading=false;
                 
               }).catch(error => {
                        console.log(error)
                        this.loading=false;
                });
                
        },
   getNodeRules(nodeId, dimId){
        this.loading=true;
             const url = this.$store.getters.proxyurl + "https://eadvantage.siemens.com/remote/release/node/" + nodeId.toString() + "/noderules/below?dimlevelId=" + dimId.toString();
             
             //return for the async await
                 return axios({ method: 'get',url: url,headers: {'Accept': 'application/json','Content-Type': 'x-www-form-urlencoded',},auth: {username: this.$store.getters.navigatorUsername,password: this.$store.getters.navigatorPassword},
            }).then(response => {
              this.nodeData.push()
                 this.loading=false;
                 
               }).catch(error => {
                        console.log(error)
                        this.loading=false;
                });
           },
           
           
    async getRuleReadinessData(){
    await this.getNodeDimensions(this.nodeId);
    
       //Get all params urls for a script
       let ParamsPromiseArray = []
       let nodeId = this.nodeId;
       for(var j = 0; j< this.nodeDimensions.length; j++){
       let dimensionId = this.nodeDimensions[j].id;
       let url = this.$store.getters.proxyurl + "https://eadvantage.siemens.com/remote/release/node/" + nodeId.toString() + "/noderules/below?dimlevelId=" + dimensionId.toString();
       ParamsPromiseArray.push(axios.get(url, {headers: {'Accept': 'application/json','Content-Type': 'x-www-form-urlencoded',},auth: {username:this.$store.getters.navigatorUsername,password: this.$store.getters.navigatorPassword}}))
       }

       this.loading=true;
       
       await axios.all(ParamsPromiseArray).then((responseArray)=>{
       console.log(responseArray);
       responseArray.forEach((response)=>{
       console.log(response);
       response.data.forEach((item)=>{
       this.nodeData.push(item);
          this.loading=false;
       });
     
       });
       }).catch((error) => {
       console.log(error);
          this.loading=false;
        });
        
     
        return console.log("done")
}    
   
  
  },
  mounted() {
  }
}
</script>

<style scoped>
</style>
